// Generated from clob-dex compiled ABI error fragments.
// Keep this list ABI-canonical: user-defined value types and enums must use their compiled ABI types.
//
// Thin shell: the signature payload lives in ./contractErrorSignatures.json so
// this module stays within the source-file line cap. The exported value and its
// consumed shape (a readonly list of `Error(argTypes)` signature strings) are
// unchanged.
import signatures from "./contractErrorSignatures.json";

export const CONTRACT_ERROR_SIGNATURES: readonly string[] = signatures;
